// extracted by mini-css-extract-plugin
export default {"card":"F4-z"};